import React from 'react'
import { SignatureContrat } from '../Types/Class/SignatureContrat'
import { CREDIT_OPTIONS } from '../Constants/creditOptions'

interface CreditsSectionProps {
    credits: SignatureContrat[]
    setCredits: (credits: SignatureContrat[]) => void
    newCredit: { CreditsAchetes: number; NoCmd: string }
    setNewCredit: (credit: { CreditsAchetes: number; NoCmd: string }) => void
    editingCreditId: number | null
    setEditingCreditId: (id: number | null) => void
    handleAddCredit: () => void
    handleUpdateCredit: (index: number) => void
    handleDeleteCredit: (index: number) => void
    getTotalCredits: () => { achetes: number; consommes: number; restants: number }
}

export default function CreditsSection({
    credits,
    setCredits,
    newCredit,
    setNewCredit,
    editingCreditId,
    setEditingCreditId,
    handleAddCredit,
    handleUpdateCredit,
    handleDeleteCredit,
    getTotalCredits
}: CreditsSectionProps) {
    return (
        <div className="card mb-4">
            <div className="card-header">
                <h4>Gestion des crédits</h4>
            </div>
            <div className="card-body">
                {/* Add credit form */}
                <div className="row mb-3">
                    <div className="col-md-3">
                        <label>Crédits achetés *</label>
                        <select
                            className="form-control"
                            value={newCredit.CreditsAchetes}
                            onChange={(e) => setNewCredit({ ...newCredit, CreditsAchetes: parseInt(e.target.value) })}
                        >
                            {CREDIT_OPTIONS.map(value => (
                                <option key={value} value={value}>
                                    {value.toLocaleString()}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label>Numéro du bon de commande *</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Numéro du bon de commande"
                            value={newCredit.NoCmd}
                            onChange={(e) => setNewCredit({ ...newCredit, NoCmd: e.target.value })}
                        />
                    </div>
                    <div className="col-md-3 d-flex align-items-end">
                        <button onClick={handleAddCredit} className="btn btn-success">
                            Ajouter
                        </button>
                    </div>
                </div>

                {/* Credits table */}
                {credits.length > 0 && (
                    <table className="table table-bordered table-sm">
                        <thead className="thead-light">
                            <tr>
                                <th>Crédits achetés</th>
                                <th>Numéro du bon de commande</th>
                                <th>Date de modification</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {credits.map((credit, index) => (
                                <tr key={credit.IDSignatureParametreContrat}>
                                    <td>
                                        {editingCreditId === index ? (
                                            <select
                                                className="form-control form-control-sm"
                                                value={credit.CreditsAchetes}
                                                onChange={(e) => {
                                                    const updated = [...credits]
                                                    updated[index].CreditsAchetes = parseInt(e.target.value)
                                                    setCredits(updated)
                                                }}
                                            >
                                                {CREDIT_OPTIONS.map(value => (
                                                    <option key={value} value={value}>
                                                        {value.toLocaleString()}
                                                    </option>
                                                ))}
                                            </select>
                                        ) : (
                                            credit.CreditsAchetes.toLocaleString()
                                        )}
                                    </td>
                                    <td>
                                        {editingCreditId === index ? (
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={credit.NoCmd}
                                                onChange={(e) => {
                                                    const updated = [...credits]
                                                    updated[index].NoCmd = e.target.value
                                                    setCredits(updated)
                                                }}
                                            />
                                        ) : (
                                            credit.NoCmd
                                        )}
                                    </td>
                                    <td>
                                        {credit.DateUpd ? new Date(credit.DateUpd).toLocaleDateString() : '-'}
                                    </td>
                                    <td>
                                        {editingCreditId === index ? (
                                            <button
                                                className="btn btn-sm btn-success mr-2"
                                                onClick={() => handleUpdateCredit(index)}
                                            >
                                                <i className="fa fa-check"></i>
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-sm btn-primary mr-2"
                                                onClick={() => setEditingCreditId(index)}
                                            >
                                                <i className="fa fa-edit"></i>
                                            </button>
                                        )}
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() => handleDeleteCredit(index)}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            <tr className="table-info">
                                <td><strong>Total acheté</strong></td>
                                <td><strong>Total consommé</strong></td>
                                <td colSpan={2}><strong>Total restant</strong></td>
                            </tr>
                            <tr className="table-info">
                                <td>{getTotalCredits().achetes.toLocaleString()}</td>
                                <td>{getTotalCredits().consommes.toLocaleString()}</td>
                                <td colSpan={2}>{getTotalCredits().restants.toLocaleString()}</td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}
